var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoManufacturerAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4061 35.2084L44.1665 39.8438V36.25C44.1665 35.3125 43.0728 34.6875 42.2394 35.2084L34.9998 39.8438V29.5834C34.9998 28.9063 34.4269 28.3334 33.7498 28.3334H27.9165C27.1873 28.3334 26.6665 28.9063 26.6665 29.5834V50.4167C26.6665 51.1459 27.1873 51.6667 27.9165 51.6667H52.0832C52.7603 51.6667 53.3332 51.1459 53.3332 50.4167V36.25C53.3332 35.3125 52.2394 34.6875 51.4061 35.2084ZM50.8332 49.1667H29.1665V30.8334H32.4998V42.0834C32.4998 43.073 33.5415 43.698 34.3748 43.1771L41.6665 38.5417V42.0834C41.6665 43.073 42.7082 43.698 43.5415 43.1771L50.8332 38.5417V49.1667Z",
    fill: "#808285"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6559 49.5342C19.9164 49.9611 19.6631 50.9067 20.09 51.6461C20.5169 52.3856 21.4625 52.639 22.202 52.212L59.3441 30.768C60.0836 30.3411 60.3369 29.3955 59.91 28.6561C59.4831 27.9166 58.5375 27.6632 57.798 28.0902L20.6559 49.5342Z",
    fill: "#808285",
    stroke: "#F4F4F4",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoManufacturerAccounts);
export default __webpack_public_path__ + "static/media/no-manufacturer-accounts.6cbde9002316937cd103a11681037326.svg";
export { ForwardRef as ReactComponent };